import { createSlice } from "@reduxjs/toolkit";

/**
 *
 *
 * @type LeadStoreState
 */
const initialState = {
  leadList: { loading: false, data: null, error: null },
  leadListCRUD: { loading: false, data: null, error: null },
  createLead: { loading: false, data: null, error: null },
  updateLead: { loading: false, data: null, error: null },
  updateLeadStage: { loading: false, data: null, error: null },
  addLeadNote: { loading: false, data: null, error: null },
  deleteLeadNote: { loading: false, data: null, error: null },
  getlastLead: { loading: false, data: null, error: null },
  kpis: { loading: false, data: null, error: null },
};

/**
 * @typedef {Object} UpdateLeadStageAction
 * @property {*} type
 * @property {LeadStageChange} payload
 */

/**
 * @typedef {Object} AddLeadNoteAction
 * @property {*} type
 * @property {AddLeadNoteStoreState} payload
 */

export const LeadSlice = createSlice({
  name: "lead",
  initialState,
  reducers: {
    fetchLeadListRequest: (state, action) => {
      state.leadList.loading = false;
      state.leadList.error = null;
    },
    fetchLeadListSuccess: (state, action) => {
      state.leadList.data = action.payload;
      state.leadList.loading = false;
      state.leadList.error = null;
    },
    fetchLeadListFailure: (state, action) => {
      state.leadList.data = null;
      state.leadList.loading = false;
      state.leadList.error = action.payload;
    },
    fetchLeadListRequestNew: (state, action) => {
      state.leadList.loading = true;
      state.leadList.error = null;
    },
    fetchLeadListSuccessNew: (state, action) => {
      state.leadList.data = action.payload;
      state.leadList.loading = false;
      state.leadList.error = null;
    },
    fetchLeadListFailureNew: (state, action) => {
      state.leadList.data = null;
      state.leadList.loading = false;
      state.leadList.error = action.payload;
    },
    fetchLeadListCRUDRequest: (state, action) => {
      state.leadListCRUD.loading = true;
      state.leadListCRUD.error = null;
    },
    fetchLeadListCRUDSuccess: (state, action) => {
      state.leadListCRUD.data = action.payload;
      state.leadListCRUD.loading = false;
      state.leadListCRUD.error = null;
    },
    fetchLeadListCRUDFailure: (state, action) => {
      state.leadListCRUD.data = null;
      state.leadListCRUD.loading = false;
      state.leadListCRUD.error = action.payload;
    },
    createLeadRequest: (state, action) => {
      state.createLead.loading = true;
      state.createLead.error = null;
    },
    createLeadSuccess: (state, action) => {
      state.createLead.data = action.payload;
      state.createLead.loading = false;
      state.createLead.error = null;
      state.leadList = addNewLead(action.payload, { ...state.leadList });
    },
    createLeadFailure: (state, action) => {
      state.createLead.data = null;
      state.createLead.loading = false;
      state.createLead.error = action.payload;
    },
    resetCreateLeadState: (state, action) => {
      state.createLead = initialState.createLead;
    },
    updateLeadRequest: (state, action) => {
      state.updateLead.loading = true;
      state.updateLead.error = null;
    },
    updateLeadSuccess: (state, action) => {
      state.updateLead.data = action.payload;
      state.updateLead.loading = false;
      state.updateLead.error = null;
      state.leadList = updateLead(action.payload, { ...state.leadList });
    },
    updateLeadFailure: (state, action) => {
      state.updateLead.data = null;
      state.updateLead.loading = false;
      state.updateLead.error = action.payload;
    },
    resetUpdateLeadState: (state, action) => {
      state.updateLead = initialState.updateLead;
    },
    /**
     *
     * @param {UpdateLeadStageAction} action
     */
    updateLeadStageRequest: (state, action) => {
      state.updateLeadStage.loading = true;
      state.updateLeadStage.error = null;
    },
    /**
     *
     * @param {UpdateLeadStageAction} action
     */
    updateLeadStageSuccess: (state, action) => {
      state.updateLeadStage.data = action.payload;
      state.updateLeadStage.loading = false;
      state.updateLeadStage.error = null;
      state.leadList = updateLeadStage(action.payload, { ...state.leadList });
    },
    /**
     *
     * @param {UpdateLeadStageAction} action
     */
    updateLeadStageFailure: (state, action) => {
      state.updateLeadStage.data = null;
      state.updateLeadStage.loading = false;
      state.updateLeadStage.error = action.payload;
    },

    /**
     *
     * @param {AddLeadNoteStoreState} state
     */
    addLeadNoteRequest: (state, action) => {
      state.addLeadNote.loading = true;
      state.addLeadNote.error = null;
    },
    /**
     *
     * @param {AddLeadNoteAction} action
     */
    addLeadNoteSuccess: (state, action) => {
      state.addLeadNote.data = action.payload;
      state.addLeadNote.loading = false;
      state.addLeadNote.error = null;
      state.leadList = updateLead(action.payload, { ...state.leadList });
    },
    /**
     *
     * @param {AddLeadNoteAction} action
     */
    addLeadNoteFailure: (state, action) => {
      state.addLeadNote.data = null;
      state.addLeadNote.loading = false;
      state.addLeadNote.error = action.payload;
    },

    /**
     *
     * @param {AddLeadNoteStoreState} state
     */
    deleteLeadNoteRequest: (state, action) => {
      state.deleteLeadNote.loading = true;
      state.deleteLeadNote.error = null;
    },
    /**
     *
     * @param {AddLeadNoteAction} action
     */
    deleteLeadNoteSuccess: (state, action) => {
      state.deleteLeadNote.data = action.payload;
      state.deleteLeadNote.loading = false;
      state.deleteLeadNote.error = null;
      state.leadList = removeLeadNote(action.payload, state.leadList);
    },
    /**
     *
     * @param {AddLeadNoteAction} action
     */
    deleteLeadNoteFailure: (state, action) => {
      state.deleteLeadNote.data = null;
      state.deleteLeadNote.loading = false;
      state.deleteLeadNote.error = action.payload;
    },
    getlastLeadRequest: (state, action) => {
      state.getlastLead.loading = true;
      state.getlastLead.error = null;
    },
    getlastLeadSuccess: (state, action) => {
      state.getlastLead.data = action.payload;
      state.getlastLead.loading = false;
      state.getlastLead.error = null;
    },
    getlastLeadFaliure: (state, action) => {
      state.getlastLead.data = null;
      state.getlastLead.loading = false;
      state.getlastLead.error = action.payload;
    },
    getKPISRequest: (state, action) => {
      state.kpis.loading = true;
      state.kpis.error = null;
    },
    getKPISSuccess: (state, action) => {
      state.kpis.data = action.payload;
      state.kpis.loading = false;
      state.kpis.error = null;
    },
    getKPISFaliure: (state, action) => {
      state.kpis.data = null;
      state.kpis.loading = false;
      state.kpis.error = action.payload;
    },
  },
});

/**
 *
 * @param {LeadForm} dataToUpdate
 * @param {LeadListStoreState} state
 * @returns {LeadListStoreState}
 */
function addNewLead(dataToUpdate, state) {
  state.data.data = [dataToUpdate, ...state.data.data];
  state.data.total++;
  return state;
}

/**
 *
 * @param {LeadForm} dataToUpdate
 * @param {LeadListStoreState} state
 * @returns {LeadListStoreState}
 */
function updateLead(dataToUpdate, state) {
  state.data.data = state.data.data.map((lead) => {
    if (lead._id !== dataToUpdate._id) return lead;
    return { ...lead, ...dataToUpdate };
  });
  return state;
}

/**
 *
 * @param {*} dataToUpdate
 * @param {LeadListStoreState} state
 * @returns {LeadListStoreState}
 */
function updateLeadNote(dataToUpdate, state) {
  state.data.data = state.data.data.map((lead) => {
    if (lead._id !== dataToUpdate._id) return lead;
    return {
      ...lead,
      notes: lead.notes ? lead.notes.concat([dataToUpdate]) : [dataToUpdate],
    };
  });
  return state;
}

/**
 *
 * @param {*} dataToRemove
 * @param {LeadListStoreState} state
 * @returns {LeadListStoreState}
 */
function removeLeadNote(dataToRemove, state) {
  state.data.data = state.data.data.map((lead) => {
    if (lead._id !== dataToRemove.leadId) return lead;
    if (!lead.notes?.length) return lead;

    return {
      ...lead,
      notes: lead.notes.filter((note) => note._id !== dataToRemove.noteId),
    };
  });
  return state;
}

/**
 *
 * @param {LeadStageChange} stageData
 * @param {*} state
 * @returns
 */
function updateLeadStage(stageData, state) {
  state.data.data = state.data.data.map((lead) => {
    if (lead._id !== stageData._id) return lead;
    return {
      ...lead,
      leadStage: stageData.leadStage,
      leadStatusReason: stageData.leadStatusReason,
    };
  });
  return state;
}

export const {
  addLeadNoteFailure,
  addLeadNoteSuccess,
  addLeadNoteRequest,

  fetchLeadListRequest,
  fetchLeadListRequestNew,
  fetchLeadListSuccess,
  fetchLeadListSuccessNew,
  fetchLeadListFailure,
  fetchLeadListFailureNew,

  fetchLeadListCRUDRequest,
  fetchLeadListCRUDSuccess,
  fetchLeadListCRUDFailure,

  createLeadFailure,
  createLeadRequest,
  createLeadSuccess,
  updateLeadFailure,
  updateLeadRequest,
  updateLeadSuccess,
  updateLeadStageFailure,
  updateLeadStageRequest,
  updateLeadStageSuccess,
  deleteLeadNoteFailure,
  deleteLeadNoteRequest,
  deleteLeadNoteSuccess,
  resetCreateLeadState,
  resetUpdateLeadState,
  getlastLeadRequest,
  getlastLeadSuccess,
  getlastLeadFaliure,
  getKPISRequest,
  getKPISSuccess,
  getKPISFaliure,
} = LeadSlice.actions;

/**
 *
 * @param {LeadStoreState} state
 * @returns {LeadStoreState}
 */
export const getLeadListState = (state) => state.newLead;

/**
 *
 * @param {LeadStoreState} state
 * @returns {LeadStoreState['createLead']}
 */
export const getLeadCreateStatus = (state) => state.newLead?.createLead;

/**
 *
 * @param {LeadStoreState} state
 * @returns {LeadStoreState['updateLead']}
 */
export const getLeadUpdateStatus = (state) => state.newLead?.updateLead;
export const getLastLeadData = (state) => state.newLead?.getlastLead;
export const getLastLeadDataNew = (state) => state.newLead?.getlastLead;
export const getKPIS = (state) => state.newLead?.kpis;
export const getListCRUD = (state) => state.newLead.leadListCRUD;
export default LeadSlice.reducer;
